export default __webpack_public_path__ + "static/media/direction.df6404fb.svg";